import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import Header from "../components/Header.js";

const About = () => {
  return (
    <div className="bg-light min-vh-100">
      <Header />

      {/* --- Section Hero --- */}
      <section className="py-5 text-white" style={{ background: "linear-gradient(135deg, #2d3436 0%, #000 100%)" }}>
        <Container className="py-5 text-center">
          <Badge bg="warning" className="mb-3 px-3 py-2 text-dark fw-bold">MISSION 2026</Badge>
          <h1 className="display-3 fw-bold mb-4 animate__animated animate__fadeIn">
            Réinventer la <span style={{ color: "#f5721e" }}>Cantine Digitale</span>
          </h1>
          <p className="lead mx-auto" style={{ maxWidth: "700px", opacity: 0.9 }}>
            COMMANDO n'est pas qu'une application. C'est le pont entre l'excellence culinaire 
            et l'innovation logicielle sur notre campus.
          </p>
        </Container>
      </section>

      <Container className="my-5 py-4">
        {/* --- Vision & Valeurs --- */}
        <Row className="mb-5 g-4">
          <Col md={6}>
            <div className="p-5 bg-white rounded-4 shadow-sm h-100 d-flex flex-column justify-content-center">
              <h2 className="fw-bold mb-4" style={{ borderLeft: "5px solid #f5721e", paddingLeft: "15px" }}>
                Pourquoi COMMANDO ?
              </h2>
              <p className="text-muted fs-5 lh-lg">
                Né de l'observation des files d'attente interminables, notre solution permet de 
                <span className="fw-bold text-dark"> digitaliser l'effort</span>. Nous permettons aux étudiants 
                de commander en un clic et d'être livrés directement, valorisant ainsi chaque minute de leur temps.
              </p>
            </div>
          </Col>
          <Col md={6}>
            <img 
              src="https://cdn.pixabay.com/photo/2017/01/26/02/06/platter-2009590_1280.jpg" 
              alt="Plat gastronomique" 
              className="img-fluid rounded-4 shadow"
              style={{ height: "100%", objectFit: "cover" }}
            />
          </Col>
        </Row>

        {/* --- L'Auteur --- */}
        <section className="py-5">
          <h2 className="text-center fw-bold mb-5">Le Visage derrière le Code</h2>
          <Row className="justify-content-center">
            <Col md={5}>
              <Card className="border-0 shadow-lg text-center overflow-hidden author-card">
                <div style={{ height: "300px", overflow: "hidden" }}>
                  <Card.Img variant="top" src="images/about/djoni.jpg" style={{ transition: "0.5s" }} />
                </div>
                <Card.Body className="p-4">
                  <h3 className="fw-bold">Djoni OUEDANOU</h3>
                  <Badge bg="info" className="mb-3">Architecte Solution</Badge>
                  <Card.Text className="text-muted italic">
                    "Innover pour mon campus est ma plus grande motivation. 
                    Utiliser Laravel et React pour résoudre des problèmes concrets."
                  </Card.Text>
                  <div className="d-flex justify-content-center gap-2 mt-3">
                     <span className="badge rounded-pill bg-dark">Laravel</span>
                     <span className="badge rounded-pill bg-dark">React JS</span>
                     <span className="badge rounded-pill bg-dark">MySQL</span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </section>

        {/* --- Dualité SIL & HTR --- */}
        <section className="py-5">
          <Row className="g-4 align-items-center mb-5">
            <Col md={6}>
               <div className="ratio ratio-16x9 shadow-lg rounded-4 overflow-hidden">
                <video autoPlay muted loop playsInline>
                  <source src={`${process.env.PUBLIC_URL}/videos/sil.mp4`} type="video/mp4" />
                </video>
               </div>
            </Col>
            <Col md={6} className="ps-md-5">
              <h3 className="fw-bold display-6">Expertise <span style={{color: "#f5721e"}}>SIL</span></h3>
              <p className="text-muted fs-5">
                Derrière chaque bouton se cache une logique complexe de gestion de stock, de notifications 
                temps réel et de sécurité des données, orchestrée par les talents de l'informatique.
              </p>
            </Col>
          </Row>

          <Row className="g-4 align-items-center flex-row-reverse">
            <Col md={6}>
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-5 border-warning">
                <h3 className="fw-bold display-6">Excellence <span className="text-warning">HTR</span></h3>
                <p className="text-muted fs-5">
                  La gastronomie rencontre la logistique. Les étudiants HTR transforment chaque commande 
                  en une expérience culinaire digne d'un service hôtelier premium.
                </p>
              </div>
            </Col>
            <Col md={6}>
              <Row className="g-2">
                <Col xs={6}>
                  <img src="images/about/patisserie.jpg" className="img-fluid rounded-3" alt="Patisserie" />
                </Col>
                <Col xs={6}>
                  <img src="https://cdn.pixabay.com/photo/2015/08/25/03/50/restaurant-906140_1280.jpg" className="img-fluid rounded-3" alt="Cuisine" />
                </Col>
              </Row>
            </Col>
          </Row>
        </section>
      </Container>

      {/* --- Footer Engagement --- */}
      <section className="py-5 mt-5" style={{ backgroundColor: "#f5721e" }}>
        <Container className="text-white text-center">
          <h2 className="fw-bold mb-5">Nos Engagements</h2>
          <Row className="g-4">
            {[
              { icon: "🚀", title: "Vitesse", text: "Zéro attente, 100% focus." },
              { icon: "🎓", title: "Savoir-faire", text: "Valoriser nos filières." },
              { icon: "🧡", title: "Communauté", text: "Par nous, pour vous." }
            ].map((item, i) => (
              <Col md={4} key={i}>
                <div className="p-4 bg-white bg-opacity-10 rounded-pill">
                  <h1 className="mb-2">{item.icon}</h1>
                  <h4 className="fw-bold">{item.title}</h4>
                  <p className="small mb-0 opacity-75">{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* --- CSS Additionnel --- */}
      <style>{`
        .author-card:hover img {
          transform: scale(1.1);
        }
        .author-card {
          transition: 0.3s;
        }
        .author-card:hover {
          transform: translateY(-10px);
        }
      `}</style>
    </div>
  );
};

export default About;